// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TfpP","colBig":"styles_colBig__1Dp-4","colSmall":"styles_colSmall__3Y3W9","shopifyNameWrapper":"styles_shopifyNameWrapper__2Ss7X"};